import { AxiosResponse } from "axios";
import { GetCurrentLogin } from "../account/AccountStore";

import axios from "../general/HttpClient";
import { difference, keys } from "lodash";

//@ts-ignore
const identityURL = identityServer;

let userCache = {};
let groupCache = {};

export function ResolveGroups(groups): Promise<IdentityGroup[]> {
    let missing = groups;

    missing = difference(groups, keys(groupCache));
    if (missing.length === 0) {
        return Promise.resolve(groups.map((u) => groupCache[u]));
    } else {
        return axios.post(`${identityURL}api/Groups/$resolve`, missing).then((response) => {
            response.data.forEach((u) => (groupCache[u.id] = u));
            return groups.map((u) => groupCache[u]);
        });
    }
}

export function ResolveUsers(users, delegated = false): Promise<IdentityUser[]> {
    let missing = users;
    if (!delegated) {
        missing = difference(users, keys(userCache));
        if (missing.length === 0) {
            return Promise.resolve(users.map((u) => userCache[u]));
        } else {
            return axios.post(`${identityURL}api/Users/$resolve`, { users: missing }).then((response) => {
                response.data.forEach((u) => (userCache[u.id] = u));
                return users.map((u) => userCache[u]);
            });
        }
    } else {
        return axios.post(`${identityURL}api/Users/$resolve`, { users: missing, delegated }).then((response) => response.data);
    }
}

export function GetUserInfo() {
    return axios.get(`${identityURL}connect/userinfo`);
}

export function GetIdentityGroups(organizationId) {
    return axios.get(`${identityURL}api/Groups/${organizationId}`).then((response) => {
        return response.data;
    });
}

export function GetIdentityGroupMembers(groupId) {
    return axios.get(`${identityURL}api/Groups/${groupId}/members`).then((response) => {
        return response.data;
    });
}

export function GetOrganizations() {
    return axios.get(`${identityURL}api/Organizations/`).then((response) => {
        return response.data;
    });
}

export function SearchUsers(organization, filter) {
    let headers = { "x-sca-ide-org-context": organization };

    return axios
        .post(
            `${identityURL}api/Users/searchUsers`,
            {
                query: filter,
            },
            { headers }
        )
        .then((response) => {
            return response.data;
        });
}

export async function GetOrganization(organizationId) {
    let user = await GetCurrentLogin();

    let headers = { "x-sca-ide-org-context": organizationId || user.getClaim("sca-organization") };

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios.get(`${identityURL}api/Organizations/${organizationId}`, { headers }).then((response) => {
        return response.data;
    });
}

export async function LoadEmailTemplates(organizationId): Promise<SendGridResult<EmailTemplate[]>> {
    let user = await GetCurrentLogin();

    let headers = { "x-sca-ide-org-context": organizationId || user.getClaim("sca-organization") };

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios.get(`${identityURL}api/Email/emailTemplates`, { headers }).then((response) => {
        return response.data;
    });
}

export async function LoadEmailTemplate(organizationId, id, version): Promise<EmailTemplateVersionWithContent> {
    let user = await GetCurrentLogin();

    let headers = { "x-sca-ide-org-context": organizationId || user.getClaim("sca-organization") };

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios
        .get(`${identityURL}api/Email/emailTemplate`, {
            params: {
                id,
                version,
            },
            headers,
        })
        .then((response) => {
            return response.data;
        });
}
export async function GetSendGridManagedService(organizationId): Promise<ManagedServiceViewModel[]> {
    let user = await GetCurrentLogin();

    let headers = { "x-sca-ide-org-context": organizationId || user.getClaim("sca-organization") };

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios.get(`${identityURL}api/ManagedServices/ListManagedServices/${organizationId || user.getClaim("sca-organization")}/7`, { headers }).then((response) => {
        return response.data;
    });
}

export interface SendGridResult<T> {
    result: T;
}

export interface EmailTemplate {
    id: string;
    name: string;
    generation: string;
    updated_at: string;
    versions: EmailTemplateVersion[];
}

export interface EmailTemplateVersion {
    id: string;
    template_id: string;
    active: number;
    name: string;
    generate_plain_content: boolean;
    subject: string;
    updated_at: string;
    editor: string;
    thumbnail_url: string;
}

export interface EmailTemplateVersionWithContent {
    id: string;
    template_id: string;
    active: number;
    name: string;
    html_content: string;
    plain_content: string;
    generate_plain_content: boolean;
    subject: string;
    test_data: any;
    updated_at: string;
    editor: string;
    thumbnail_url: string;
}

export interface ManagedServiceViewModel {
    iD: string;
    organizationID: string;
    type: number;
    typeName: string;
    configuration: { [key: string]: any };
}

export interface IdentityUser {
    organization: string;
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    photo: string;
    lastLoginDate: string;
    fullName: string;
    displayName: string;
    groups: IdentityGroup[];
}

export interface IdentityGroup {
    id: string;
    name: string;
    type: number;
    source: string;
    sourceID: string;
    organizationID: string;
    groupCustomTypeID: string;
    groupCustomTypeName: string;
    groupCustomTypeSource: string;
    groupCustomTypeSourceID: string;
    description: string;
}
